import { Observable } from 'rxjs';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { UseCase } from '../../base/use-case';
import { TypeServiceModel } from '../../models/configuration/type-service.model';

export class GetTypeServiceUseCase implements UseCase<void, TypeServiceModel> {
  constructor(private configRepository: ConfigurationRepository) {}
  execute(): Observable<TypeServiceModel> {
    return this.configRepository.getTypeService();
  }
}
